import completedProjectIcon from "../../assets/dental-inden/icons/completedProject.svg";
import activeProjectsIcon from "../../assets/dental-inden/icons/activeProject.svg";
import colaboratedProjectsIcon from "../../assets/dental-inden/icons/colaboratedProjects.svg";
import totalProjectsIcon from "../../assets/dental-inden/icons/totalProject.svg";
import createNewProject from "../../assets/dental-inden/icons/createNewProject.svg";
import dashboardGraph from "../../assets/dental-inden/images/dashboard-graph.svg";
import userAddicon from "../../assets/dental-inden/icons/userAdd.svg";
import drawerBackArrow from "../../assets/dental-inden/icons/d-back-arrow.svg";
import searchIcon from "../../assets/dental-inden/icons/searchIcon.svg";
import binIcon from "../../assets/dental-inden/icons/bin.svg";
import searchWhite from "../../assets/dental-inden/icons/searchWhite.svg";
import viewIcon from "../../assets/dental-inden/icons/viewIcon.svg";
import shareIcon from "../../assets/dental-inden/icons/shareIcon.svg";
import collaboratorIcon from "../../assets/dental-inden/icons/collaboratorIcon.svg";
import emptySteper from "../../assets/dental-inden/icons/emptySteper.svg";
import fillSteper from "../../assets/dental-inden/icons/fillSteper.svg";
import toothType from "../../assets/dental-inden/icons/dental-marking/tooth_type.svg";
import dentalRecordAdded from "../../assets/dental-inden/icons/dental-marking/dental_record_added.svg";
import addedCses from "../../assets/dental-inden/icons/addedCses.svg";
import pendingCases from "../../assets/dental-inden/icons/pendingCases.svg";
import dentalRecord from "../../assets/dental-inden/icons/dentalRecord.svg";
import viewEyeIcon from "../../assets/dental-inden/icons/viewEyeIcon.svg";
import caseDeleteIcon from "../../assets/dental-inden/icons/caseDeleteIcon.svg";
import caseDetailIcon from "../../assets/dental-inden/icons/caseDetailIcon.svg";
import tickIcon from "../../assets/dental-inden/icons/tickIcon.svg";
import crossIcon from "../../assets/dental-inden/icons/crossIcon.svg";
import newIcon from "../../assets/dental-inden/icons/newIcon.svg";
import rounderPlusIcon from "../../assets/dental-inden/icons/rounderPlusIcon.svg";
import arrowDown from "../../assets/dental-inden/icons/arrow-down.svg";
import arrowUp from "../../assets/dental-inden/icons/arrow-up.svg";
import closeModal from "../../assets/dental-inden/icons/closeModal.svg";
import projectCompletedIcon from "../../assets/dental-inden/icons/projectCompletedIcon.svg";
import projectArchiveIcon from "../../assets/dental-inden/icons/projectArchiveIcon.svg";
import plusButtonIcon from "../../assets/dental-inden/icons/plusButtonIcon.svg";
import breadCrumbIcon from "../../assets/dental-inden/icons/breadCrumbIcon.svg";
import deleteIcon from "../../assets/dental-inden/icons/binIcon.svg";
import editIcon from "../../assets/dental-inden/icons/EditIcon.svg";
import deactivateIcon from "../../assets/dental-inden/icons/deactivateIcon.svg";
import download from "../../assets/dental-inden/icons/Download.svg";
import seatsIcon from "../../assets/dental-inden/icons/seatsIcon.svg";
import crossredIcon from "../../assets/dental-inden/icons/crossredIcon.svg";
import linearIcon from "../../assets/dental-inden/icons/linearIcon.svg";
import polygonIcon from "../../assets/dental-inden/icons/polygonIcon.svg";
import secondOpinion from "../../assets/dental-inden/icons/secondOpinion.svg";
import identificationIcon from "../../assets/dental-inden/icons/identificationIcon.svg";
import ageAssessmentIcon from "../../assets/dental-inden/icons/ageAssessmentIcon.svg";
import accessDenied from "../../assets/images/access-denied.svg";
import subscriptionExpired from "../../assets/images/subscriptionExpired.svg";
import confirmationPlan from "../../assets/images/confirmationPlan.png";
import rightSideNew from "../../assets/images/rightSideNew.png";
// quadrant 1
import fq18 from "../../assets/dental-inden/icons/dental-marking/fq1/fq18.svg";
import fq17 from "../../assets/dental-inden/icons/dental-marking/fq1/fq17.svg";
import fq16 from "../../assets/dental-inden/icons/dental-marking/fq1/fq16.svg";
import fq15 from "../../assets/dental-inden/icons/dental-marking/fq1/fq15.svg";
import fq14 from "../../assets/dental-inden/icons/dental-marking/fq1/fq14.svg";
import fq13 from "../../assets/dental-inden/icons/dental-marking/fq1/fq13.svg";
import fq12 from "../../assets/dental-inden/icons/dental-marking/fq1/fq12.svg";
import fq11 from "../../assets/dental-inden/icons/dental-marking/fq1/fq11.svg";

// quadrant 2
import fq41 from "../../assets/dental-inden/icons/dental-marking/fq2/fq41.svg";
import fq42 from "../../assets/dental-inden/icons/dental-marking/fq2/fq42.svg";
import fq43 from "../../assets/dental-inden/icons/dental-marking/fq2/fq43.svg";
import fq44 from "../../assets/dental-inden/icons/dental-marking/fq2/fq44.svg";
import fq45 from "../../assets/dental-inden/icons/dental-marking/fq2/fq45.svg";
import fq46 from "../../assets/dental-inden/icons/dental-marking/fq2/fq46.svg";
import fq47 from "../../assets/dental-inden/icons/dental-marking/fq2/fq47.svg";
import fq48 from "../../assets/dental-inden/icons/dental-marking/fq2/fq48.svg";

// quadrant 3
import fq21 from "../../assets/dental-inden/icons/dental-marking/fq3/fq21.svg";
import fq22 from "../../assets/dental-inden/icons/dental-marking/fq3/fq22.svg";
import fq23 from "../../assets/dental-inden/icons/dental-marking/fq3/fq23.svg";
import fq24 from "../../assets/dental-inden/icons/dental-marking/fq3/fq24.svg";
import fq25 from "../../assets/dental-inden/icons/dental-marking/fq3/fq25.svg";
import fq26 from "../../assets/dental-inden/icons/dental-marking/fq3/fq26.svg";
import fq27 from "../../assets/dental-inden/icons/dental-marking/fq3/fq27.svg";
import fq28 from "../../assets/dental-inden/icons/dental-marking/fq3/fq28.svg";
// quadrant 4
import fq31 from "../../assets/dental-inden/icons/dental-marking/fq4/fq31.svg";
import fq32 from "../../assets/dental-inden/icons/dental-marking/fq4/fq32.svg";
import fq33 from "../../assets/dental-inden/icons/dental-marking/fq4/fq33.svg";
import fq34 from "../../assets/dental-inden/icons/dental-marking/fq4/fq34.svg";
import fq35 from "../../assets/dental-inden/icons/dental-marking/fq4/fq35.svg";
import fq36 from "../../assets/dental-inden/icons/dental-marking/fq4/fq36.svg";
import fq37 from "../../assets/dental-inden/icons/dental-marking/fq4/fq37.svg";
import fq38 from "../../assets/dental-inden/icons/dental-marking/fq4/fq38.svg";

// missing
import missingM1 from "../../assets/dental-inden/icons/dental-marking/missing/missingM-1.svg";
import missingMA from "../../assets/dental-inden/icons/dental-marking/missing/missingM-A.svg";
import missingMB from "../../assets/dental-inden/icons/dental-marking/missing/missingM-B.svg";
import missingMP from "../../assets/dental-inden/icons/dental-marking/missing/missingM-P.svg";

// restored
import restoredRA from "../../assets/dental-inden/icons/dental-marking/restored/restoredR-A.svg";
import restoredRC from "../../assets/dental-inden/icons/dental-marking/restored/restoredR-C.svg";
import restoredRP from "../../assets/dental-inden/icons/dental-marking/restored/restoredR-P.svg";
import restoredRR from "../../assets/dental-inden/icons/dental-marking/restored/restoredR-R.svg";

// present
import presentPM from "../../assets/dental-inden/icons/dental-marking/present/presentP-M.svg";
import presentPP from "../../assets/dental-inden/icons/dental-marking/present/presentP-P.svg";
import presentPS from "../../assets/dental-inden/icons/dental-marking/present/presentP-S.svg";
import presentPV from "../../assets/dental-inden/icons/dental-marking/present/presentP-V.svg";

// landmark

import landmarkLB from "../../assets/dental-inden/icons/dental-marking/landmark/landmarkL-B.svg";
import landmarkLC from "../../assets/dental-inden/icons/dental-marking/landmark/landmarkL-C.svg";
import landmarkLM from "../../assets/dental-inden/icons/dental-marking/landmark/landmarkL-M.svg";
import landmarkLO from "../../assets/dental-inden/icons/dental-marking/landmark/landmarkL-O.svg";

import testTeeth from "../../assets/teeths/testTeeth.svg";
import dentaIdShowcase from "../../assets/images/dentaIdShowcase.png";

import upgradeSubscription from "../../assets/dental-inden/icons/upgrade-subs.svg";

// image analysis
import projectAnalysisIcon from "../../assets/image-analysis/project-analysis-icon.svg";
import projectAnalysisIconPending from "../../assets/image-analysis/project-analysis-icon-pending.svg";
import deleteProjectAnalysisIcon from "../../assets/image-analysis/delete-analysis-project.svg";
import editProjectAnalysisIcon from "../../assets/image-analysis/edit-analysis-project.svg";
import openProjectAnalysisIcon from "../../assets/image-analysis/open-project.svg";
import analysisHeaderIcon from "../../assets/image-analysis/analysis-icon.svg";
import dentalLogo from "../../assets/image-analysis/dentalLogo.png";
import areaIcon from "../../assets/image-analysis/areaIcon.svg";
import angleIcon from "../../assets/image-analysis/angleIcon.svg";
import leanerIcon from "../../assets/image-analysis/leanerIcon.svg";
import uploadImageIcon from "../../assets/image-analysis/uploadImageIcon.svg";
import exportData from "../../assets/image-analysis/exportData.svg";
import calculator from "../../assets/image-analysis/calculator.svg";
import handTool from "../../assets/image-analysis/hand-tool.svg";
import moveTool from "../../assets/image-analysis/moveIcon.svg";
import resizeTool from "../../assets/image-analysis/resize-tool.svg";
import textTool from "../../assets/image-analysis/text-tool.svg";
import chatTool from "../../assets/image-analysis/chat-tool.svg";
import leanerTool from "../../assets/image-analysis/leaner-tool.svg";
import angleTool from "../../assets/image-analysis/angle-tool.svg";
import areaTool from "../../assets/image-analysis/area-tool.svg";
import allProjectsIcon from "../../assets/image-analysis/all-projects-icon.svg";
import secondOpicon from "../../assets/image-analysis/second-op-icon.svg";
import backCalculator from "../../assets/image-analysis/back-calculator.svg";
import calculatorIcon from "../../assets/image-analysis/calculatorIcon.svg";
import invertIcon from "../../assets/image-analysis/invert-icon.svg";
import resolveIcon from "../../assets/image-analysis/resolve-icon.svg";
import dotsIcon from "../../assets/image-analysis/dots-icon.svg";
import closeIcon from "../../assets/image-analysis/close-icon.svg";
import linear from "../../assets/image-analysis/linear.svg";
import angles from "../../assets/image-analysis/angle.svg";
import polygons from "../../assets/image-analysis/polygons.svg";
import importPoly from "../../assets/image-analysis/import-poly.svg";
import backProjects from "../../assets/image-analysis/back-projects.svg";
import estimateAge from "../../assets/image-analysis/estimate-age.svg";
import plusMinus from "../../assets/icons/plus-minus.png";
import newProjectIcon from "../../assets/image-analysis/new-project-icon.svg";
import deleteProjectIcon from "../../assets/image-analysis/delete-project-icon.svg";
import estimateAiAge from "../../assets/image-analysis/estimate-ai-age.svg";
import importPolygon from "../../assets/image-analysis/import-polygon.svg";
import chewronLeft from "../../assets/image-analysis/chewron-left.svg";
import polyArea from "../../assets/image-analysis/poly-area.svg";
import polyPrimter from "../../assets/image-analysis/poly-primter.svg";
import shapeArrow from "../../assets/image-analysis/shape-arrow.svg";
import rotationIcon from "../../assets/image-analysis/rotationIcon.svg";
import rotateRight from "../../assets/image-analysis/rotate-90.svg";
import rotateAngle from "../../assets/image-analysis/rotate-angle.svg";
import bottomArrow from "../../assets/image-analysis/bottomArrow.svg";
import areaDiff from "../../assets/image-analysis/area-diff.svg";
import periDiff from "../../assets/image-analysis/pera-diff.svg";
import clearResult from "../../assets/image-analysis/clear-result.svg";
import magnifier from "../../assets/image-analysis/magnifier.svg";
import plus from "../../assets/image-analysis/plus.svg";
import minus from "../../assets/image-analysis/minus.svg";
import editPencilIcon from "../../assets/image-analysis/editPencilIcon.svg";
import calendarIcon from "../../assets/image-analysis/calendarIcon.svg";
import clockIcon from "../../assets/image-analysis/clockIcon.svg";
import verticalDots from "../../assets/image-analysis/verticalDots.svg";
import toothPlaceholder from "../../assets/image-analysis/toothPlaceholder.png";
import screenshot from "../../assets/image-analysis/screenshot.svg";
import angle_tool from "../../assets/image-analysis/angleTool.svg";
import polygonTool from "../../assets/image-analysis/polygonTool.svg";
import lineTool from "../../assets/image-analysis/lineTool.svg";
import deleteAll from "../../assets/image-analysis/delete-all.svg";
import textToolIcon from "../../assets/image-analysis/text-tool-t.svg";
import upToolTip from "../../assets/image-analysis/upToolTip.svg";
import logoAnalysis from "../../assets/image-analysis/logo-analysis.svg";
import openArrow from "../../assets/image-analysis/openArrow.svg";
import closeArrow from "../../assets/image-analysis/closeArrow.svg";
import dotIcon from "../../assets/image-analysis/dotIcon.svg";
import flipIcon from "../../assets/image-analysis/flip-hori.svg";
import dentalIdLogo from "../../assets/image-analysis/dental-logo.svg";
import uploadNewImage from "../../assets/image-analysis/uploadNewImage.svg";
import resetIcon from "../../assets/image-analysis/resetIcon.svg";
import resetDelIcon from "../../assets/image-analysis/resetDelIcon.svg";
import decision from "../../assets/image-analysis/decision.svg";
import resetCross from "../../assets/image-analysis/resetCross.svg";
// side bar
import cropIcon from "../../assets/image-analysis/cropIcon.svg";
import deleteObjectIcon from "../../assets/image-analysis/deleteIcon.svg";
import clearAllIcon from "../../assets/image-analysis/clearAllIcon.svg";
import openIcon from "../../assets/image-analysis/openIcon.svg";
import verticalLine from "../../assets/image-analysis/vertical-line.svg";
import horizontalLine from "../../assets/image-analysis/horizontal-line.svg";
import leftIcon from "../../assets/image-analysis/left.svg";
import rightIcon from "../../assets/image-analysis/right.svg";
import upIcon from "../../assets/image-analysis/up.svg";
import downIcon from "../../assets/image-analysis/down.svg";

export const dentalIcons = {
  completedProjectIcon,
  activeProjectsIcon,
  colaboratedProjectsIcon,
  totalProjectsIcon,
  createNewProject,
  dashboardGraph,
  userAddicon,
  drawerBackArrow,
  searchIcon,
  binIcon,
  searchWhite,
  viewIcon,
  shareIcon,
  collaboratorIcon,
  emptySteper,
  fillSteper,
  //quadrant1
  fq18,
  fq17,
  fq16,
  fq15,
  fq14,
  fq13,
  fq12,
  fq11,
  //quadrant2
  fq48,
  fq47,
  fq46,
  fq45,
  fq44,
  fq43,
  fq42,
  fq41,
  //quadrant3
  fq21,
  fq22,
  fq23,
  fq24,
  fq25,
  fq26,
  fq27,
  fq28,
  //quadrant4
  fq31,
  fq32,
  fq33,
  fq34,
  fq35,
  fq36,
  fq37,
  fq38,
  // present
  presentPM,
  presentPP,
  presentPS,
  presentPV,
  // restored
  restoredRA,
  restoredRC,
  restoredRP,
  restoredRR,
  // missing
  missingM1,
  missingMA,
  missingMB,
  missingMP,
  // landmrark
  landmarkLB,
  landmarkLC,
  landmarkLM,
  landmarkLO,
  toothType,
  dentalRecordAdded,
  pendingCases,
  addedCses,
  dentalRecord,
  viewEyeIcon,
  caseDeleteIcon,
  caseDetailIcon,
  tickIcon,
  crossIcon,
  newIcon,
  rounderPlusIcon,
  arrowDown,
  arrowUp,
  closeModal,
  projectArchiveIcon,
  projectCompletedIcon,
  plusButtonIcon,
  breadCrumbIcon,
  deleteIcon,
  editIcon,
  deactivateIcon,
  download,
  seatsIcon,
  crossredIcon,
  linearIcon,
  polygonIcon,
  secondOpinion,
  ageAssessmentIcon,
  identificationIcon,
  accessDenied,
  subscriptionExpired,
  confirmationPlan,
  testTeeth,
  dentaIdShowcase,
  upgradeSubscription,
  projectAnalysisIcon,
  projectAnalysisIconPending,
  deleteProjectAnalysisIcon,
  editProjectAnalysisIcon,
  openProjectAnalysisIcon,
  analysisHeaderIcon,
  dentalLogo,
  areaIcon,
  angleIcon,
  leanerIcon,
  uploadImageIcon,
  exportData,
  calculator,
  handTool,
  moveTool,
  allProjectsIcon,
  cropIcon,
  openIcon,
  deleteObjectIcon,
  clearAllIcon,
  verticalLine,
  horizontalLine,
  rightIcon,
  upIcon,
  downIcon,
  leftIcon,
  resizeTool,
  textTool,
  chatTool,
  angleTool,
  leanerTool,
  areaTool,
  secondOpicon,
  backCalculator,
  calculatorIcon,
  invertIcon,
  resolveIcon,
  dotsIcon,
  closeIcon,
  linear,
  angles,
  polygons,
  importPoly,
  backProjects,
  estimateAge,
  plusMinus,
  newProjectIcon,
  deleteProjectIcon,
  estimateAiAge,
  importPolygon,
  chewronLeft,
  polyArea,
  polyPrimter,
  shapeArrow,
  rotationIcon,
  rotateRight,
  rotateAngle,
  bottomArrow,
  areaDiff,
  periDiff,
  clearResult,
  magnifier,
  plus,
  minus,
  editPencilIcon,
  calendarIcon,
  clockIcon,
  verticalDots,
  toothPlaceholder,
  screenshot,
  lineTool,
  polygonTool,
  angle_tool,
  deleteAll,
  textToolIcon,
  upToolTip,
  logoAnalysis,
  closeArrow,
  openArrow,
  dotIcon,
  flipIcon,
  dentalIdLogo,
  uploadNewImage,
  resetIcon,
  resetDelIcon,
  decision,
  resetCross,
  rightSideNew,
};
